import {Injectable} from "@angular/core";
import {EntityData} from "@fedeltapointofsale/data-client";
import {Subject} from "rxjs";


export class EditGridAddRowSearchSelectResults {
    data: any[];

    constructor(data: any[]) {
        this.data = data;
    }
}

export class EditGridAddRowNewSelectResults {
    entity: EntityData<any>;

    constructor(entity: EntityData<any>) {
        this.entity = entity;
    }
}

export class EditGridAddRowQuickSelectResults {
    entity: EntityData<any>;

    constructor(entity: EntityData<any>) {
        this.entity = entity;
    }
}

@Injectable()
export class EditGridAddRowService {

    onSearchSelect: Subject<EditGridAddRowSearchSelectResults> = new Subject<EditGridAddRowSearchSelectResults>();
    onNewSelect: Subject<EditGridAddRowNewSelectResults> = new Subject<EditGridAddRowNewSelectResults>();
    onQuickSelect: Subject<EditGridAddRowQuickSelectResults> = new Subject<EditGridAddRowQuickSelectResults>();
    onNew: Subject<void> = new Subject<void>();

    addSearchSelect(searchSelectResults: EditGridAddRowSearchSelectResults): void {
        this.onSearchSelect.next(searchSelectResults);
    }

    addNewSelect(newSelectResults: EditGridAddRowNewSelectResults): void {
        this.onNewSelect.next(newSelectResults);
    }

    addQuickSelect(quickSelectResults: EditGridAddRowQuickSelectResults): void {
        this.onQuickSelect.next(quickSelectResults);
    }

    addNew(): void {
        this.onNew.next();
    }
}
